module.exports = __webpack_public_path__ + "media/images/bars_filter-9637fe10.svg";